import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { AppComponent } from './app.component';
import { CommonMaterialModule } from './common/common-material.module';
import { AppRoutingModule } from './app-routing.module';
import { SessionGuard } from './auth/session-guard.service';
import { SessionService } from './common/session.service';
import { FilterService } from './search/filter.service';
import { TxnService } from './txns/txn.service';
import { ApiClient } from './common/api-client.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonMaterialModule,
    AppRoutingModule,
  ],
  providers: [
    DatePipe,
    SessionGuard,
    SessionService,
    FilterService,
    TxnService,
    ApiClient,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /srv/src/app/app.module.ts